import Vue from 'vue'
import Router from 'vue-router'
import Enrollment from '@/components/Enrollment'

Vue.use(Router)

export default new Router({
  mode: 'history',
  hash: false,
  routes: [
    {
      path: '/',
      name: 'enrollment',
      component: Enrollment
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js